import root from 'window-or-global';
import React from 'react';
import {Helmet} from 'react-helmet';
import parse from 'url-parse';

export function getAssetPath(asset) {
    return `${root.__webpack_asset_path || ''}${asset}`;
}

let suffix = ' - Epic Online Services';

export const setSuffix = newSuffix => {
    suffix = newSuffix;
};

// Manipulates the title string passed in to remove "Unreal Engine | " and append " - Unreal Engine"
export const titleAppend = title => {
    if (!title) return '';

    //remove prefixed 'Unreal Engine |'
    let updatedTitle = title.replace(/^Epic Online Services \| /i, '');

    //remove - Unreal Engine variations
    updatedTitle = updatedTitle.replace('– Epic Online Services', '');
    updatedTitle = updatedTitle.replace('- Epic Online Services', '');

    //remove encoded ampersands
    updatedTitle = updatedTitle.replace('&amp;', '&');

    //trim trailing spaces
    updatedTitle = updatedTitle.replace(/\s$/, '');

    //apend - Unreal Engine as suffix
    updatedTitle = updatedTitle += suffix;
    return updatedTitle;
};

export function getTagsFromModel(pageModel) {
    if (!pageModel) return {tags: null, title: null};

    const metaTags = pageModel._metaTags || null;
    const tagMatches = metaTags ? metaTags.match(/<meta(.*?)>/gim) : [];
    const titleMatches = metaTags ? metaTags.match(/<title>(.*?)<\/title>/gim) : [];

    const tags = [];
    if (tagMatches && tagMatches.length) {
        tagMatches.forEach(t => {
            const tag = {};

            let name = t.match(/name="(.*?)"/);
            if (name && name[1]) {
                name = name[1];
                tag.name = name;
            }

            let property = t.match(/property="(.*?)"/);
            if (property && property[1]) {
                property = property[1];
                tag.property = property;
            }

            let content = t.match(/content="(.*?)"/);
            if (content && content[1]) {
                content = content[1];
                tag.content = content;
            }

            tags.push(tag);
        });
    }

    let title = pageModel._title || '';
    if (titleMatches && titleMatches.length) {
        title = titleMatches[0].replace('<title>', '').replace('</title>', '');
    }
    const appendedTitle = titleAppend(title);

    const currentUrl = parse(root.location.href);
    currentUrl.set('hash', '');
    currentUrl.set('query', '');

    const links = [
        {
            rel: 'canonical',
            href: currentUrl.toString()
        }
    ];

    tags.push({
        property: 'og:url',
        content: currentUrl.toString()
    });

    return {tags, title: appendedTitle, links};
}

export function getHelmetForMetaTags(pageModel, publisherName) {
    if (!pageModel) return null;

    publisherName && setSuffix(` - ${publisherName}`);

    const {tags, title, links} = getTagsFromModel(pageModel);

    return <Helmet link={links} meta={tags} title={title} />;
}
